/**
 * Lightweight analytics event tracker.
 * Fires to Google Analytics (gtag) and Meta Pixel (fbq) if loaded.
 * Logs to console in development.
 */
export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window === 'undefined') return;
    if (window.gtag) window.gtag('event', eventName, params);
    if (window.fbq) window.fbq('trackCustom', eventName, params);
    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics]', eventName, params);
    }
  } catch (_) {
    // Analytics must never break the UI
  }
};
